(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var QR_MAX_BYTES = 8 * 1024 * 1024;
  var QR_MIN_EDGE = 960;
  var QR_MAX_EDGE = 1800;
  var skuIndexPromise = null;

  function stripBrandPrefix(s) {
    return String(s || '')
      .trim()
      .replace(/^ooky[\s-]*doky\s*[:：]\s*/i, '')
      .replace(/^ookydoky\s*[:：]\s*/i, '')
      .replace(/^ookydoky\s*\.?\s*com\s*[:：\/]?\s*/i, '')
      .trim();
  }

  function normalizeSku(raw) {
    var s = stripBrandPrefix(raw);
    if (!s) return '';

    try {
      if (/^https?:\/\//i.test(s)) {
        var u = new URL(s);
        var skuParam = u.searchParams.get('sku') || u.searchParams.get('SKU');
        if (skuParam) return stripBrandPrefix(skuParam);

        var parts = u.pathname.split('/').filter(Boolean);
        var idx = parts.indexOf('products');
        if (idx >= 0 && parts[idx + 1]) {
          return decodeURIComponent(parts[idx + 1]);
        }
      }
    } catch (e) {
      /* ignore */
    }

    return s.replace(/^SKU[:：\s]*/i, '').trim();
  }

  function loadSkuIndex() {
    if (!skuIndexPromise) {
      skuIndexPromise = fetch(ROOT + 'assets/sku-index.json', { cache: 'no-store' })
        .then(function (r) {
          if (!r.ok) throw new Error('index');
          return r.json();
        })
        .catch(function () {
          return {};
        });
    }
    return skuIndexPromise;
  }

  function productUrlFromIndex(index, sku) {
    if (!sku || !index) return '';
    var entry = index[sku] || index[sku.toUpperCase()] || index[sku.toLowerCase()];
    if (!entry) return '';
    if (typeof entry === 'string') return entry.charAt(0) === '/' ? entry : ROOT + entry;
    if (entry.url) return entry.url.charAt(0) === '/' ? entry.url : ROOT + entry.url;
    if (entry.handle && entry.variant) {
      return ROOT + 'products/' + entry.handle + '?variant=' + entry.variant;
    }
    if (entry.handle) return ROOT + 'products/' + entry.handle;
    return '';
  }

  function searchUrlForSku(sku) {
    var clean = normalizeSku(sku);
    if (!clean) return '';
    return ROOT + 'search?type=product&q=' + encodeURIComponent(clean);
  }

  function resolveProductUrl(raw) {
    var s = stripBrandPrefix(raw);
    if (!s) return Promise.resolve('');

    try {
      if (/^https?:\/\//i.test(s)) {
        var u = new URL(s);
        var host = (u.hostname || '').toLowerCase();
        if (host.indexOf('ookydoky.com') >= 0 || host.indexOf('myshopify.com') >= 0) {
          var skuParam = u.searchParams.get('sku') || u.searchParams.get('SKU');
          if (skuParam) {
            return loadSkuIndex().then(function (index) {
              return productUrlFromIndex(index, stripBrandPrefix(skuParam)) || searchUrlForSku(skuParam);
            });
          }
          var parts = u.pathname.split('/').filter(Boolean);
          var idx = parts.indexOf('products');
          if (idx >= 0 && parts[idx + 1]) {
            var handle = decodeURIComponent(parts[idx + 1]);
            var variant = u.searchParams.get('variant');
            var url = ROOT + 'products/' + handle;
            if (variant) url += '?variant=' + variant;
            return Promise.resolve(url);
          }
        }
      }
    } catch (e) {
      /* ignore */
    }

    var sku = normalizeSku(s);
    if (!sku) return Promise.resolve('');

    return loadSkuIndex().then(function (index) {
      return productUrlFromIndex(index, sku) || searchUrlForSku(sku);
    });
  }

  function setStatus(ctx, message, show) {
    if (!ctx || !ctx.statusEl) return;
    ctx.statusEl.textContent = message || '';
    ctx.statusEl.hidden = !show;
  }

  function goToSku(raw, ctx) {
    setStatus(ctx, 'جاري البحث عن المنتج...', true);
    return resolveProductUrl(raw).then(function (url) {
      if (!url) {
        setStatus(ctx, 'لم يُعثر على منتج لهذا QR/SKU.', true);
        return false;
      }
      window.location.href = url;
      return true;
    });
  }

  function stopScanner(modal) {
    if (modal && modal._qrScanner && modal._qrScanner.isScanning) {
      modal._qrScanner.stop().catch(function () {});
    }
  }

  function loadImageSource(file) {
    return new Promise(function (resolve, reject) {
      if (typeof createImageBitmap === 'function') {
        createImageBitmap(file)
          .then(resolve)
          .catch(function () {
            fallback();
          });
        return;
      }
      function fallback() {
        var img = new Image();
        var url = URL.createObjectURL(file);
        img.onload = function () {
          URL.revokeObjectURL(url);
          resolve(img);
        };
        img.onerror = function () {
          URL.revokeObjectURL(url);
          reject(new Error('load'));
        };
        img.src = url;
      }
      fallback();
    });
  }

  function sourceSize(source) {
    return {
      w: source.naturalWidth || source.width,
      h: source.naturalHeight || source.height,
    };
  }

  function drawToCanvas(source, sx, sy, sw, sh, outW, outH) {
    var canvas = document.createElement('canvas');
    canvas.width = Math.max(1, outW);
    canvas.height = Math.max(1, outH);
    var ctx = canvas.getContext('2d', { alpha: false });
    if (!ctx) return canvas;
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';
    ctx.drawImage(source, sx, sy, sw, sh, 0, 0, canvas.width, canvas.height);
    return canvas;
  }

  function fitScale(w, h, factor) {
    var edge = Math.max(w, h) * factor;
    if (edge < QR_MIN_EDGE) return QR_MIN_EDGE / Math.max(w, h);
    if (edge > QR_MAX_EDGE) return QR_MAX_EDGE / Math.max(w, h);
    return factor;
  }

  function buildScanCanvases(source) {
    var size = sourceSize(source);
    var w = size.w;
    var h = size.h;
    var canvases = [];
    var regions = [
      { sx: 0, sy: 0, sw: w, sh: h, label: 'full' },
      { sx: 0, sy: 0, sw: w, sh: Math.floor(h * 0.38), label: 'top' },
      { sx: 0, sy: 0, sw: w, sh: Math.floor(h * 0.22), label: 'top-small' },
    ];
    var factors = [1, 1.5, 2, 3];

    regions.forEach(function (region) {
      factors.forEach(function (factor) {
        var scale = fitScale(region.sw, region.sh, factor);
        var outW = Math.round(region.sw * scale);
        var outH = Math.round(region.sh * scale);
        canvases.push(drawToCanvas(source, region.sx, region.sy, region.sw, region.sh, outW, outH));
      });
    });

    return canvases;
  }

  function preprocessCanvas(canvas, mode) {
    var out = document.createElement('canvas');
    out.width = canvas.width;
    out.height = canvas.height;
    var ctx = out.getContext('2d');
    if (!ctx) return canvas;
    ctx.drawImage(canvas, 0, 0);
    var img = ctx.getImageData(0, 0, out.width, out.height);
    var d = img.data;

    for (var i = 0; i < d.length; i += 4) {
      var r = d[i];
      var g = d[i + 1];
      var b = d[i + 2];
      var gray = 0.299 * r + 0.587 * g + 0.114 * b;

      if (mode === 'gray') {
        d[i] = d[i + 1] = d[i + 2] = gray;
      } else if (mode === 'invert') {
        var inv = 255 - gray;
        d[i] = d[i + 1] = d[i + 2] = inv;
      } else if (mode === 'threshold') {
        var t = gray > 140 ? 255 : 0;
        d[i] = d[i + 1] = d[i + 2] = t;
      } else if (mode === 'green') {
        var isDark = g < 130 && r < 150 && b < 150;
        var v = isDark ? 0 : 255;
        d[i] = d[i + 1] = d[i + 2] = v;
      }
    }

    ctx.putImageData(img, 0, 0);
    return out;
  }

  function tryJsQr(canvas) {
    if (typeof jsQR === 'undefined') return null;
    var ctx = canvas.getContext('2d');
    if (!ctx) return null;
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var code = jsQR(imageData.data, imageData.width, imageData.height, {
      inversionAttempts: 'attemptBoth',
    });
    return code && code.data ? code.data : null;
  }

  function tryBarcodeDetector(canvas) {
    if (typeof BarcodeDetector === 'undefined') {
      return Promise.resolve(null);
    }
    return createImageBitmap(canvas)
      .then(function (bitmap) {
        var detector = new BarcodeDetector({ formats: ['qr_code'] });
        return detector.detect(bitmap).then(function (codes) {
          bitmap.close();
          if (codes && codes.length && codes[0].rawValue) return codes[0].rawValue;
          return null;
        });
      })
      .catch(function () {
        return null;
      });
  }

  function tryHtml5Qrcode(canvas) {
    if (typeof Html5Qrcode === 'undefined') {
      return Promise.resolve(null);
    }
    return new Promise(function (resolve) {
      canvas.toBlob(function (blob) {
        if (!blob) {
          resolve(null);
          return;
        }
        Html5Qrcode.scanFile(blob, false)
          .then(function (text) {
            resolve(text || null);
          })
          .catch(function () {
            resolve(null);
          });
      }, 'image/png');
    });
  }

  function tryDecodeCanvas(canvas) {
    var js = tryJsQr(canvas);
    if (js) return Promise.resolve(js);
    return tryBarcodeDetector(canvas).then(function (det) {
      if (det) return det;
      return tryHtml5Qrcode(canvas);
    });
  }

  function decodeQrFromFile(file) {
    return loadImageSource(file).then(function (source) {
      var canvases = buildScanCanvases(source);
      if (source && typeof source.close === 'function') {
        source.close();
      }

      var variants = [];
      canvases.forEach(function (canvas) {
        variants.push(canvas);
        ['gray', 'threshold', 'invert', 'green'].forEach(function (mode) {
          variants.push(preprocessCanvas(canvas, mode));
        });
      });

      var chain = Promise.resolve(null);
      variants.forEach(function (canvas) {
        chain = chain.then(function (found) {
          if (found) return found;
          return tryDecodeCanvas(canvas);
        });
      });

      return chain.then(function (found) {
        if (found) return found;
        throw new Error('no_qr');
      });
    });
  }

  function widgetContext(el) {
    var widget = el.closest('[data-qr-sku-widget]') || el.closest('.qr-sku-search-modal') || document.body;
    return {
      widget: widget,
      statusEl: widget.querySelector('[data-qr-status]'),
      fileInput: widget.querySelector('[data-qr-file]'),
      _qrFileBusy: false,
    };
  }

  function scanImageFile(ctx, file) {
    if (!file || ctx._qrFileBusy) return;

    if (!file.type || file.type.indexOf('image/') !== 0) {
      setStatus(ctx, 'الرجاء اختيار ملف صورة.', true);
      return;
    }
    if (file.size > QR_MAX_BYTES) {
      setStatus(ctx, 'الصورة كبيرة جداً. اختر صورة أصغر.', true);
      return;
    }

    ctx._qrFileBusy = true;
    setStatus(ctx, 'جاري قراءة QR...', true);
    if (ctx.widget && ctx.widget.classList.contains('qr-sku-search-modal')) {
      stopScanner(ctx.widget);
    }

    decodeQrFromFile(file)
      .then(function (decoded) {
        return goToSku(decoded, ctx);
      })
      .catch(function () {
        setStatus(ctx, 'لم يُعثر على QR. جرّب صورة أوضح أو قصّص منطقة الرمز.', true);
      })
      .finally(function () {
        ctx._qrFileBusy = false;
      });
  }

  function bindWidget(widget) {
    if (!widget || widget.dataset.bound === '1') return;
    widget.dataset.bound = '1';

    var ctx = widgetContext(widget);
    var pickBtn = widget.querySelector('[data-qr-sku-pick]');
    var fileInput = ctx.fileInput;
    var input = widget.querySelector('[data-qr-input]');
    var submit = widget.querySelector('[data-qr-submit]');
    var closeBtn = widget.querySelector('[data-qr-close]');
    var overlay = widget.querySelector('[data-qr-overlay]');

    if (pickBtn && fileInput) {
      pickBtn.addEventListener('click', function () {
        fileInput.click();
      });
    }

    if (fileInput) {
      fileInput.addEventListener('change', function (e) {
        var file = e.target.files && e.target.files[0];
        if (file) scanImageFile(ctx, file);
        fileInput.value = '';
      });
    }

    if (submit && input) {
      submit.addEventListener('click', function () {
        goToSku(input.value, ctx);
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') goToSku(input.value, ctx);
      });
    }

    function closeModal() {
      widget.classList.remove('is-open');
      widget.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      stopScanner(widget);
      ctx._qrFileBusy = false;
    }

    [closeBtn, overlay].forEach(function (el) {
      if (el) el.addEventListener('click', closeModal);
    });
  }

  function startScanner(modal) {
    var readerId = modal.getAttribute('data-reader-id');
    var ctx = widgetContext(modal);
    if (!readerId || typeof Html5Qrcode === 'undefined') return;
    if (modal._qrScanner && modal._qrScanner.isScanning) return;

    var scanner = new Html5Qrcode(readerId);
    modal._qrScanner = scanner;

    Html5Qrcode.getCameras()
      .then(function (cameras) {
        if (!cameras || !cameras.length) return;
        var camId = cameras[cameras.length - 1].id;
        return scanner.start(
          camId,
          { fps: 8, qrbox: { width: 220, height: 220 } },
          function (decoded) {
            goToSku(decoded, ctx).then(function (ok) {
              if (ok) scanner.stop().catch(function () {});
            });
          },
          function () {}
        );
      })
      .catch(function () {});
  }

  function initWidgets() {
    document.querySelectorAll('[data-qr-sku-widget], .qr-sku-search-modal').forEach(bindWidget);

    var pageModal = document.getElementById('QrSkuSearchPageModal');
    if (pageModal) startScanner(pageModal);
  }

  function autoRedirectFromQuery() {
    var params = new URLSearchParams(window.location.search);
    var sku = params.get('sku') || params.get('SKU');
    if (sku) goToSku(sku, widgetContext(document.body));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initWidgets();
      autoRedirectFromQuery();
    });
  } else {
    initWidgets();
    autoRedirectFromQuery();
  }
})();
